export default "__VITE_ASSET__BekvMjVD__"